import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import MoreTimeOutlinedIcon from '@mui/icons-material/MoreTimeOutlined';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import { useLayoutBottomBar } from './layout-bottom-bar.hooks';
import ClientFormDialog from '@features/client/components/client-form/client-form-dialog';
import ServiceFormDialog from '@features/service/components/service-form-dialog';
import { StockItemFormDialog } from '@features/stock/components/stock-item-form-dialog';
import { VisitFormDialog } from '@features/visits/components/visit-form/visit-form-dialog';
import { BottomNavigation } from '@shared/components/bottom-bar/bottom-bar-navigation';
import { BottomNavigationAction } from '@shared/components/bottom-bar/bottom-bar-navigation-action';
import { useEffect } from 'react';
import {
  BOTTOM_BAR_DIALOG_ACTION_EVENT,
  BottomBarDialogActionEventDetail,
} from './layout-bottom-bar-actions';

export const LayoutBottomBar = () => {
  const { colorScheme, t, clientDialogRef, visitDialogRef, stockItemDialogRef, serviceDialogRef } =
    useLayoutBottomBar();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleDialogAction = (event: Event) => {
      const customEvent = event as CustomEvent<BottomBarDialogActionEventDetail>;

      switch (customEvent.detail?.action) {
        case 'openClientDialog':
          clientDialogRef.current?.open();
          break;
        case 'openVisitDialog':
          visitDialogRef.current?.open();
          break;
        case 'openStockItemDialog':
          stockItemDialogRef.current?.open();
          break;
        case 'openServiceDialog':
          serviceDialogRef.current?.open();
          break;
        default:
          break;
      }
    };

    window.addEventListener(BOTTOM_BAR_DIALOG_ACTION_EVENT, handleDialogAction);

    return () => {
      window.removeEventListener(BOTTOM_BAR_DIALOG_ACTION_EVENT, handleDialogAction);
    };
  }, [clientDialogRef, visitDialogRef, stockItemDialogRef, serviceDialogRef]);

  return (
    <>
      <BottomNavigation bgColor={colorScheme}>
        <BottomNavigationAction
          ref={serviceDialogRef}
          icon={<ContentCutIcon fontSize="large" />}
          label={t('serviceDialog.addService')}
          color="white"
        />
        <BottomNavigationAction
          ref={clientDialogRef}
          icon={<PersonAddAlt1OutlinedIcon fontSize="large" />}
          label={t('clientDialog.addClient')}
          color="white"
        />
        <BottomNavigationAction
          ref={visitDialogRef}
          icon={<MoreTimeOutlinedIcon fontSize="large" />}
          label={t('addVisit.order')}
          color="common.white"
        />
        <BottomNavigationAction
          ref={stockItemDialogRef}
          icon={<WarehouseIcon fontSize="large" />}
          label={t('stock.addStockItem')}
          color="common.white"
        />
      </BottomNavigation>
      <ClientFormDialog dialogRef={clientDialogRef} enableAllowedServices={false} />
      <VisitFormDialog dialogRef={visitDialogRef} />
      <StockItemFormDialog
        dialogRef={stockItemDialogRef}
        formUsagePurpose="purchaseAndNewStockItem"
      />
      <ServiceFormDialog dialogRef={serviceDialogRef} />
    </>
  );
};
